import {
  REACHLIST
} from '../actions/reach';
import {reducerPackage} from "../../utils";

export const reachList = reducerPackage(REACHLIST);

